__turbopack_context__.v({
  "content": "ArticleCard-module__p6ZWhG__content",
  "featuredImageBackground": "ArticleCard-module__p6ZWhG__featuredImageBackground",
  "featuredLink": "ArticleCard-module__p6ZWhG__featuredLink",
  "featuredPreamble": "ArticleCard-module__p6ZWhG__featuredPreamble",
  "featuredTitle": "ArticleCard-module__p6ZWhG__featuredTitle",
  "image": "ArticleCard-module__p6ZWhG__image",
  "imageBackground": "ArticleCard-module__p6ZWhG__imageBackground",
  "link": "ArticleCard-module__p6ZWhG__link",
  "preamble": "ArticleCard-module__p6ZWhG__preamble",
  "root": "ArticleCard-module__p6ZWhG__root",
  "tag": "ArticleCard-module__p6ZWhG__tag",
  "title": "ArticleCard-module__p6ZWhG__title",
});
